import React from 'react';

import { LiveChatContext, useLiveChatContextState } from 'components/LiveChat/LiveChatContext';
import LiveChatView from 'components/LiveChat/LiveChatView';

const LiveChatContainer = ({ children }) => {
  const liveChatContextState = useLiveChatContextState();

  return (
    <LiveChatContext.Provider value={liveChatContextState}>
      {children}
      <LiveChatView />
    </LiveChatContext.Provider>
  );
};

export default LiveChatContainer;
